import {
  markDocChatTurnCancelled,
  markDocChatTurnError,
} from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatConversation'
import type { DocChatConversation } from 'features/knowledgeDocumentViewer/types'

export type DocChatStopOutcome = {
  turnId: string
  status: 'in-flight' | 'completed' | 'cancelled' | 'error'
}

export function applyDocChatStopOutcome({
  conversation,
  outcome,
  siteId,
}: {
  conversation: DocChatConversation
  outcome: DocChatStopOutcome
  siteId: string
}): DocChatConversation {
  if (
    conversation.activeTurnId !== outcome.turnId ||
    outcome.status === 'in-flight' ||
    outcome.status === 'completed'
  )
    return conversation
  if (outcome.status === 'error') {
    return markDocChatTurnError({
      conversation,
      turnId: outcome.turnId,
      siteId,
    })
  }
  return markDocChatTurnCancelled({ conversation, turnId: outcome.turnId })
}
